import type { Connection } from '@utils/types/connections/connection.ts';

/**
 * Operator policy helpers. Scriptix staff decide which platforms an
 * organization may use and whether it may switch on YouTube uploads; the
 * org admin only configures connections inside that. The server enforces
 * it, these helpers only decide what the UI shows.
 */

/** A missing flag means allowed, so an older backend behaves as before. */
export const isPlatformAllowed = (
  connection: Pick<Connection, 'platform_allowed'> | null | undefined
): boolean => connection?.platform_allowed !== false;

/** Strict: the upload toggle is hidden unless the operator allowed it. */
export const canEnableVideoUploads = (
  connection: Pick<Connection, 'video_uploads_allowed'> | null | undefined
): boolean => connection?.video_uploads_allowed === true;
